import { createStore } from '@stencil/store';
import { NAVBAR_HEIGHT } from '../../constants';
import { OneAPIHelper } from '../../utils/api/one.api';

function isHighContrastTheme() {
  if (localStorage.getItem('theme')) return localStorage.getItem('theme') === 'highContrast';

  return false;
}

const navbarStore = createStore({
  showSearchControl: true,

  isLoggedIn: Boolean(OneAPIHelper.isLoggedIn()),
  loading: false,
  simplified: false,
  showNavbar: true,
  showAccessibilityBar: false,
  navbarWillLoad: false,
  navbarDidLoad: false,
  highContrastTheme: isHighContrastTheme(),
  sidenavOpenedByKeyboard: false,
  userMenuOpenedByKeyboard: false,
  navbarHeight: NAVBAR_HEIGHT,
  userImageUrl: '',
});

export default navbarStore;
